export const ALL_COMPANIES_PANEL_LABELS = {
  title: 'All Companies',
  searchPlaceholder: 'Find Company',
  filterByFund: 'Filter by Fund',
  fundFilterSearchPlaceholder: 'Find a Fund',
  emptyFundFilterOptions: 'No funds found',
  allFunds: 'All Funds',
  emptyTitle: 'No companies found',
  emptyDescription: 'Try adjusting your search or fund filter.',
  errorTitle: 'Unable to load companies',
  errorDescription: 'Please refresh the page or try again.',
} as const;

export const ALL_COMPANIES_PANEL_SKELETON_ITEM_COUNT = 7;
